import { Box } from '@chakra-ui/react'
import type { FC, ReactElement } from 'react'

import { toaster } from '@app/components/ui/toaster'
import ConfirmPopover from '@app/shared/confirmPopover'
import { useAccountSwitchMutation } from '@graphql/queries'
import type { Account } from '@graphql/types'

interface Props {
  account: Account
  confirm?: boolean
  children?: ReactElement
}

const AccountSwitchButton: FC<Props> = ({ account, confirm = true, children = null }) => {
  const [, switchAccount] = useAccountSwitchMutation()

  const handleSwitchAccount = async () => {
    const res = await switchAccount({
      input: {
        accountId: account.id
      }
    })

    if (res.error) {
      toaster.create({
        title: 'Account switch',
        description: 'We were unable to switch your account, please contact support.',
        type: 'error'
      })
    } else {
      window.location.href = '/strategy'
    }
  }

  if (confirm === false) {
    return <Box onClick={handleSwitchAccount}>{children}</Box>
  }

  return (
    <ConfirmPopover
      onConfirm={() => handleSwitchAccount()}
      header="Switch account"
      body="Are you sure you'd like to switch accounts?"
      confirmButtonText="Confirm"
    >
      {children}
    </ConfirmPopover>
  )
}

export default AccountSwitchButton
